/* UNMAPPED - um.js. Ported from the frozen v8 mock (drawer, reveals, tabs, forms, gallery) plus the theme-only parts:
   Leaflet world map, real variants, cart drawer, phone buy bar. Vanilla, no deps (Leaflet loads only where the map is). */
(function () {
  'use strict';
  var doc = document;
  doc.documentElement.classList.remove('no-js');
  function $$(s, r) { return [].slice.call((r || doc).querySelectorAll(s)); }
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- menu drawer ---------- */
  var drawer = doc.querySelector('.um-drawer');
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    var b = doc.querySelector('.um-burger'); if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); }
  }
  doc.addEventListener('click', function (e) {
    var b = e.target.closest('.um-burger');
    if (b && drawer) {
      drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); b.setAttribute('aria-expanded', 'true');
      var c = drawer.querySelector('.um-drawer__close'); if (c) c.focus();
      return;
    }
    if (e.target.closest('.um-drawer__bg, .um-drawer__close')) closeDrawer();
  });

  /* ---------- reveals: IO + top<0 + rAF scroll sweep (LAW block 6) ---------- */
  var io = null;
  function revealSweep() {
    var vh = window.innerHeight;
    $$('.um-r:not(.in), .um-rz:not(.in)').forEach(function (el) {
      if (!el.offsetParent && getComputedStyle(el).position !== 'fixed') return;
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.86 || r.bottom < 0) el.classList.add('in');
    });
  }
  function initReveals(root) {
    var els = $$('.um-r:not(.in), .um-rz:not(.in)', root);

    if ('IntersectionObserver' in window) {
      if (!io) io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting || e.boundingClientRect.top < 0) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -12% 0px' });
      els.forEach(function (el) { io.observe(el); });
    }
    revealSweep();
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { revealSweep(); ticking = false; });
  }, { passive: true });
  window.addEventListener('load', revealSweep);


  /* ---------- MOTION LAYER (Nik 09-27): fixed header state, scroll progress, parallax, word light-up, tilt, magnetic ---------- */
  var header = doc.querySelector('.um-header');
  var fine = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var hero = doc.querySelector('.um-hero');
  var heroMedia = hero && hero.querySelector('[data-hero-media]');
  var heroCopy = hero && hero.querySelector('.um-hero__copy');
  var pars = [], lines = [], arts = [];
  function splitWords(el) {
    if (el.classList.contains('is-split')) return;
    (function walk(node) {
      [].slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = doc.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(doc.createTextNode(part)); return; }
            var w = doc.createElement('span'); w.className = 'um-w'; w.textContent = part; frag.appendChild(w);
          });
          node.replaceChild(frag, n);
        } else if (n.nodeType === 1) { walk(n); }
      });
    })(el);
    el.classList.add('is-split');
  }
  function initMotion(root) {
    if (reduced) return;
    $$('.um-manifesto__line', root).forEach(function (el) { if (!DESIGN) { splitWords(el); lines.push(el); } });
    if (fine) {
      $$('.um-card__media, .um-arrival__grid .um-sq, .um-craft__tile .um-sq', root).forEach(function (el) {
        if (el.hasAttribute('data-tilt')) return; el.setAttribute('data-tilt', '');
        el.addEventListener('pointermove', function (e) {
          var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
          el.classList.add('is-tilting'); el.style.setProperty('--ry', (x * 7).toFixed(2)); el.style.setProperty('--rx', (-y * 7).toFixed(2));
        });
        el.addEventListener('pointerleave', function () { el.classList.remove('is-tilting'); el.style.setProperty('--ry', 0); el.style.setProperty('--rx', 0); });
      });
      $$('.um-hero .um-btn, .um-app__bar .um-btn, .um-notify .um-btn, .um-cart__empty .um-btn, .um-404 .um-btn', root).forEach(function (b) {
        if (b.hasAttribute('data-mag')) return; b.setAttribute('data-mag', '');
        b.addEventListener('pointermove', function (e) {
          var r = b.getBoundingClientRect();
          b.style.setProperty('--bx', ((e.clientX - r.left - r.width / 2) * 0.22).toFixed(1));
          b.style.setProperty('--by', ((e.clientY - r.top - r.height / 2) * 0.3).toFixed(1));
        });
        b.addEventListener('pointerleave', function () { b.style.setProperty('--bx', 0); b.style.setProperty('--by', 0); });
      });
    }
  }
  if (hero && heroMedia && fine && !reduced) {
    hero.addEventListener('pointermove', function (e) {
      var r = hero.getBoundingClientRect();
      heroMedia.style.setProperty('--mx', (((e.clientX - r.left) / r.width - 0.5) * -18).toFixed(1));
      heroMedia.style.setProperty('--my', (((e.clientY - r.top) / r.height - 0.5) * -12).toFixed(1));
    });
    hero.addEventListener('pointerleave', function () { heroMedia.style.setProperty('--mx', 0); heroMedia.style.setProperty('--my', 0); });
  }
  var mTick = false;
  function motionFrame() {
    mTick = false;
    var y = window.scrollY || window.pageYOffset, vh = window.innerHeight;
    if (header) {
      header.classList.toggle('is-solid', y > 12);
      var max = Math.max(1, doc.documentElement.scrollHeight - vh);
      header.style.setProperty('--p', Math.min(1, y / max).toFixed(4));
    }
    if (reduced) return;
    if (hero && heroMedia) {
      var hh = hero.offsetHeight;
      if (y < hh + 50) {
        heroMedia.style.setProperty('--hy', (y * 0.32).toFixed(1));
        if (heroCopy) { heroCopy.style.setProperty('--hc', (y * -0.12).toFixed(1)); heroCopy.style.setProperty('--ho', Math.max(0, 1 - y / (hh * 0.75)).toFixed(3)); }
      }
    }
    lines.forEach(function (el) {
      var r = el.getBoundingClientRect(), words = el.querySelectorAll('.um-w');
      var prog = Math.max(0, Math.min(1, (vh * 0.88 - r.top) / (vh * 0.5)));
      var lit = Math.round(prog * words.length);
      for (var i = 0; i < words.length; i++) words[i].classList.toggle('is-lit', i < lit);
    });
  }
  function requestMotion() { if (!mTick) { mTick = true; requestAnimationFrame(motionFrame); } }
  window.addEventListener('scroll', requestMotion, { passive: true });
  window.addEventListener('resize', requestMotion);

  /* page fade between internal pages (skips anchors, new tabs, the cart drawer, the editor) */
  if (!reduced && !DESIGN) {
    doc.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest('a[href]'); if (!a || a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-cart-open') || a.hasAttribute('data-line-qty') || a.hasAttribute('data-pin') || a.hasAttribute('data-tab')) return;
      var u; try { u = new URL(a.href, window.location.href); } catch (x) { return; }
      if (u.origin !== window.location.origin || u.protocol.indexOf('http') !== 0) return;
      if (u.pathname === window.location.pathname && u.search === window.location.search) return; /* same page, hash jump */
      if (/^\/(cart\/|checkout|account\/logout)/.test(u.pathname)) return;
      e.preventDefault();
      doc.documentElement.classList.add('um-leaving');
      setTimeout(function () { window.location.href = a.href; }, 200);
    });
    window.addEventListener('pageshow', function (e) { doc.documentElement.classList.remove('um-leaving'); });
  }

  /* ---------- Unmapped World: Leaflet on an equirectangular image (EPSG:4326 = the image's own projection) ---------- */
  var leafletState = null; /* null | 'loading' | 'ready' */
  var leafletWaiters = [];
  function withLeaflet(src, cb) {
    if (window.L && window.L.map) { cb(); return; }
    leafletWaiters.push(cb);
    if (leafletState === 'loading') return;
    leafletState = 'loading';
    var s = doc.createElement('script'); s.src = src; s.async = true;
    s.onload = function () { leafletState = 'ready'; var w = leafletWaiters; leafletWaiters = []; w.forEach(function (f) { f(); }); };
    s.onerror = function () { leafletState = null; };
    doc.head.appendChild(s);
  }
  var PIN_SVG = '<svg class="um-pin__ico" viewBox="0 0 24 32" aria-hidden="true"><path d="M12 1C6.5 1 2 5.4 2 10.8 2 18.6 12 31 12 31s10-12.4 10-20.2C22 5.4 17.5 1 12 1z"/><circle cx="12" cy="11" r="4"/></svg>';

  function buildMap(world) {
    var el = world.querySelector('.um-world__map');
    if (!el || el.__um) return; el.__um = {};
    var view = world.querySelector('.um-world__view');
    var LT = parseFloat(el.getAttribute('data-top')) || 84, LB = parseFloat(el.getAttribute('data-bottom')) || -58;
    var src = el.getAttribute('data-src');
    var centre = [parseFloat(el.getAttribute('data-lat')) || 18, parseFloat(el.getAttribute('data-lng')) || -25];
    var phone = window.matchMedia('(max-width:767px)');
    /* Nik r2: the whole world must scroll up/down too. Start zoomed so the map is ~1.45x taller than the view
       (room to pan north/south), allow zooming out until the full height fits, and 2.2 levels in from the start. */
    var ASPECT = 360 / (LT - LB);
    function worldPx(f) { return Math.max(view.clientWidth * f.w, view.clientHeight * f.h * ASPECT); }
    function z0() { return Math.log(worldPx(phone.matches ? { w: 2.6, h: 1.45 } : { w: 1.7, h: 1.45 }) / 512) / Math.LN2; }
    function zFit() { return Math.log(Math.max(view.clientWidth, view.clientHeight * ASPECT) / 512) / Math.LN2; }
    var zBase = z0(), zMin = zFit();
    var map = L.map(el, {
      crs: L.CRS.EPSG4326, zoomControl: false, attributionControl: false,
      zoomSnap: 0, zoomDelta: 0.6, minZoom: zMin, maxZoom: zBase + 2.2,
      worldCopyJump: true, maxBounds: [[LB, -1080], [LT, 1080]], maxBoundsViscosity: 1,
      scrollWheelZoom: false, inertia: !reduced, inertiaDeceleration: 2600, bounceAtZoomLimits: false,
      fadeAnimation: false, keyboard: true
    });
    el.__um.map = map;
    [-360, 0, 360].forEach(function (o) { L.imageOverlay(src, [[LB, -180 + o], [LT, 180 + o]], { interactive: false, className: 'um-world__img' }).addTo(map); });
    map.setView(centre, zBase, { animate: false });

    var markers = {};
    function closeAll(except) {
      Object.keys(markers).forEach(function (k) { var m = markers[k].getElement(); if (m && m !== except) m.classList.remove('is-open'); });
    }
    function placeCard(m) {
      var p = map.latLngToContainerPoint(m.getLatLng());
      m.getElement().classList.toggle('flip', p.x > view.clientWidth * 0.55);
    }
    $$('.um-world__pins > li', world).forEach(function (li, i) {
      var lat = parseFloat(li.getAttribute('data-lat')), lng = parseFloat(li.getAttribute('data-lng'));
      if (isNaN(lat) || isNaN(lng)) return;
      var id = li.getAttribute('data-id');
      var icon = L.divIcon({ className: 'um-pin', html: PIN_SVG + '<b></b>' + li.innerHTML, iconSize: [44, 44], iconAnchor: [22, 40] });
      var m = L.marker([lat, lng], { icon: icon, title: li.getAttribute('data-name') || '', riseOnHover: true, keyboard: true, zIndexOffset: 0 }).addTo(map);
      var node = m.getElement(); node.style.setProperty('--i', i); node.classList.add('um-pin--drop'); node.setAttribute('role', 'button'); node.setAttribute('aria-label', li.getAttribute('data-name') || '');
      node.addEventListener('mouseenter', function () { placeCard(m); });
      m.on('click', function (e) {
        if (e.originalEvent && e.originalEvent.target.closest && e.originalEvent.target.closest('.um-pin__card')) return;
        placeCard(m);
        var open = node.classList.contains('is-open');
        closeAll(); if (!open) node.classList.add('is-open');
      });
      m.__route = parseInt(li.getAttribute('data-route'), 10) || 0;
      markers[id] = m;
    });
    map.on('click', function () { closeAll(); });
    el.__um.markers = markers;

    /* route: soft arcs through the pins in route order (quadratic curves sampled in lat/lng, which is linear in this CRS) */
    var seq = Object.keys(markers).map(function (k) { return markers[k]; }).filter(function (m) { return m.__route > 0; })
      .sort(function (a, b) { return a.__route - b.__route; }).map(function (m) { return m.getLatLng(); });
    if (seq.length > 1) {
      var pts = [seq[0]];
      for (var k = 1; k < seq.length; k++) {
        var a = seq[k - 1], b = seq[k], cLat = Math.min(LT - 2, Math.max(a.lat, b.lat) + Math.abs(b.lng - a.lng) * 0.18), cLng = (a.lng + b.lng) / 2;
        for (var t = 1; t <= 16; t++) {
          var u = t / 16, v = 1 - u;
          pts.push([v * v * a.lat + 2 * v * u * cLat + u * u * b.lat, v * v * a.lng + 2 * v * u * cLng + u * u * b.lng]);
        }
      }
      L.polyline(pts, { color: '#C9A96A', weight: 2.2, opacity: 0.55, dashArray: '14 12', className: 'um-route', interactive: false, smoothFactor: 0.5 }).addTo(map);
    }

    /* controls */
    $$('[data-zoom]', world).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        var mode = b.getAttribute('data-zoom');
        if (mode === 'in') map.zoomIn(0.6); else if (mode === 'out') map.zoomOut(0.6); else map.setView(centre, zBase);
      });
    });
    /* wheel: zoom around the cursor, but hand the wheel back to the page at either zoom limit so scrolling never gets stuck */
    view.addEventListener('wheel', function (e) {
      var z = map.getZoom(), zin = e.deltaY < 0;
      if ((zin && z >= map.getMaxZoom() - 0.001) || (!zin && z <= map.getMinZoom() + 0.001)) return;
      e.preventDefault();
      var dz = Math.max(-0.5, Math.min(0.5, -e.deltaY * (e.deltaMode === 1 ? 0.04 : 0.0022)));
      map.setZoomAround(map.mouseEventToContainerPoint(e), z + dz, { animate: false });
    }, { passive: false });
    var rt = null;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        var was = map.getZoom() - zBase; zBase = z0(); zMin = zFit();
        map.setMinZoom(zMin); map.setMaxZoom(zBase + 2.2); map.invalidateSize(); map.setZoom(Math.max(zMin, zBase + was), { animate: false });
      }, 150);
    });
    el.__um.focus = function (id) {
      var m = markers[id]; if (!m) return;
      map.panTo(m.getLatLng(), { animate: !reduced });
      setTimeout(function () { placeCard(m); closeAll(); m.getElement().classList.add('is-open'); }, reduced ? 0 : 320);
    };
    el.__um.hot = function (id, on) { var m = markers[id]; if (m && m.getElement()) { if (on) placeCard(m); m.getElement().classList.toggle('is-hot', on); } };
  }

  function initWorld(world) {
    if (world.__umInit) return; world.__umInit = true;
    var el = world.querySelector('.um-world__map');
    function go() { withLeaflet(el.getAttribute('data-leaflet'), function () { buildMap(world); }); }
    if (el) {
      if ('IntersectionObserver' in window && !DESIGN) {
        var lo = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { lo.disconnect(); go(); } }, { rootMargin: '800px 0px' });
        lo.observe(world);
      } else { go(); }
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { world.classList.toggle('in-view', e.isIntersecting); }); }, { threshold: 0.01 }).observe(world);
    } else { world.classList.add('in-view'); }
    /* tabs */
    var panels = $$('.um-app__panel', world);
    $$('[data-tab]', world).forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var id = a.getAttribute('data-tab');
        $$('[data-tab]', world).forEach(function (x) { x.classList.toggle('is-on', x === a); x.setAttribute('aria-selected', x === a ? 'true' : 'false'); });
        panels.forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-panel') === id); });
        if (id === 'explore' && el && el.__um && el.__um.map) el.__um.map.invalidateSize();
        revealSweep();
      });
    });
    /* "View all" links open their tab and bring the app bar into view */
    $$('[data-goto-tab]', world).forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = world.querySelector('.um-app__nav [data-tab="' + a.getAttribute('data-goto-tab') + '"]');
        if (!t) return;
        e.preventDefault(); t.click();
        var bar = world.querySelector('.um-app__bar');
        if (bar) window.scrollTo({ top: bar.getBoundingClientRect().top + window.scrollY - 90, behavior: reduced ? 'auto' : 'smooth' });
      });
    });
    /* rail rows and list rows: hover lights the pin, click flies to it */
    $$('[data-pin]', world).forEach(function (a) {
      var id = a.getAttribute('data-pin');
      a.addEventListener('mouseenter', function () { a.classList.add('is-hot'); if (el && el.__um && el.__um.hot) el.__um.hot(id, true); });
      a.addEventListener('mouseleave', function () { a.classList.remove('is-hot'); if (el && el.__um && el.__um.hot) el.__um.hot(id, false); });
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var ex = world.querySelector('[data-tab="explore"]'); if (ex && !ex.classList.contains('is-on')) ex.click();
        var v = world.querySelector('.um-world__view');
        if (v) v.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
        setTimeout(function () { if (el && el.__um && el.__um.focus) el.__um.focus(id); }, reduced ? 0 : 380);
      });
    });
  }

  /* ---------- share form: map choice ---------- */
  doc.addEventListener('change', function (e) {
    var r = e.target.closest('.um-sw--share input[type=radio]');
    if (!r) return;
    $$('.um-sw--share label', r.closest('.um-sw--share')).forEach(function (l) { l.classList.toggle('is-on', l.contains(r)); });
  });

  /* ---------- cart ---------- */
  var CART_SECTION = 'um-cart-drawer';
  function cartEl() { return doc.getElementById('um-cart'); }
  function setCount(n) { $$('[data-cart-count]').forEach(function (s) { s.textContent = '(' + n + ')'; }); }
  function openCart() {
    var c = cartEl(); if (!c) return false;
    c.classList.add('is-open'); c.setAttribute('aria-hidden', 'false');
    var x = c.querySelector('.um-cart__close'); if (x) x.focus();
    return true;
  }
  function closeCart() { var c = cartEl(); if (c && c.classList.contains('is-open')) { c.classList.remove('is-open'); c.setAttribute('aria-hidden', 'true'); } }
  function swapCart(html) {
    var c = cartEl(); if (!c || !html) return;
    var tmp = doc.createElement('div'); tmp.innerHTML = html;
    var fresh = tmp.querySelector('#um-cart'); if (!fresh) return;
    c.querySelector('.um-cart__panel').innerHTML = fresh.querySelector('.um-cart__panel').innerHTML;
    setCount(fresh.getAttribute('data-count') || '0');
  }
  function cartPost(url, body) {
    body.sections = CART_SECTION; body.sections_url = window.location.pathname;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { var err = new Error(j.description || j.message || 'Something went wrong'); err.data = j; throw err; } return j; }); });
  }
  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-cart-open]') && !doc.body.classList.contains('um-tpl-cart')) {
      if (openCart()) { e.preventDefault(); }
      return;
    }
    if (t.closest('.um-cart__bg, .um-cart__close')) { e.preventDefault(); closeCart(); return; }
    var q = t.closest('[data-line-qty]');
    if (q && q.closest('#um-cart')) {
      e.preventDefault();
      var c = cartEl(); c.classList.add('is-busy');
      cartPost('/cart/change.js', { line: parseInt(q.getAttribute('data-line'), 10), quantity: parseInt(q.getAttribute('data-line-qty'), 10) })
        .then(function (j) { swapCart(j.sections && j.sections[CART_SECTION]); })
        .catch(function () { window.location.href = '/cart'; })
        .then(function () { c.classList.remove('is-busy'); });
    }
  });
  doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); closeDrawer(); } });

  /* ---------- product page ---------- */
  function initProduct(pdp) {
    if (pdp.__umInit) return; pdp.__umInit = true;
    var dataEl = pdp.querySelector('[data-um-product]'); if (!dataEl) return;
    var P = JSON.parse(dataEl.textContent);
    var ci = P.colourIndex, si = P.sizeIndex;
    var soon = (P.unreleased || []).map(function (s) { return String(s).trim().toLowerCase(); }).filter(Boolean);
    var form = pdp.querySelector('form.um-pdp__form');
    var idInput = form && form.querySelector('input[name=id]');
    var cta = pdp.querySelector('.um-pdp__cta .um-btn');
    var stock = pdp.querySelector('.um-pdp__stock');
    var err = pdp.querySelector('.um-pdp__form-err');
    var notify = pdp.querySelector('.um-pdp__notify');
    var priceEl = pdp.querySelector('.um-pdp__price');
    var mainImg = pdp.querySelector('.um-gal__main img');
    var track = pdp.querySelector('.um-gal__track');
    var count = pdp.querySelector('.um-gal__count');
    var bar = doc.querySelector('.um-buybar');
    var state = { colour: null, size: null };
    var current = null;
    if (P.selected) { if (ci > -1) state.colour = P.selected.options[ci]; if (si > -1) state.size = P.selected.options[si]; }
    /* no ?variant= in the URL: start on the default size (the mock opens on M) when it is in stock */
    if (si > -1 && P.defaultSize && window.location.search.indexOf('variant=') === -1) {
      var dv = P.variants.filter(function (v) { return (ci < 0 || v.options[ci] === state.colour) && v.options[si] === P.defaultSize && v.available; })[0];
      if (dv) state.size = P.defaultSize;
    }

    function isSoon(c) { return c != null && soon.indexOf(String(c).toLowerCase()) > -1; }
    function find() {
      return P.variants.filter(function (v) {
        return (ci < 0 || v.options[ci] === state.colour) && (si < 0 || v.options[si] === state.size);
      })[0] || null;
    }
    function colourKey(c) { return String(c || '').toLowerCase().replace(/[^a-z0-9]+/g, '-'); }
    function visibleSlides() { return $$('.um-gal__track figure:not([hidden])', pdp); }
    function showGallery() {
      var key = colourKey(state.colour), first = null;
      $$('[data-media-colour]', pdp).forEach(function (n) {
        var on = ci < 0 || n.getAttribute('data-media-colour') === key;
        n.hidden = !on;
        if (on && !first && n.matches('.um-gal__thumbs button')) first = n;
      });
      $$('.um-gal__thumbs button, .um-gal__strip button', pdp).forEach(function (b) { b.classList.remove('is-on'); });
      if (first) selectMedia(first.getAttribute('data-media-id'));
      if (track) track.scrollLeft = 0;
      updateCount();
    }
    function selectMedia(id) {
      var b = pdp.querySelector('.um-gal__thumbs button[data-media-id="' + id + '"]');
      if (b && mainImg && mainImg.getAttribute('data-current') !== id) {
        var swap = function () {
          mainImg.src = b.getAttribute('data-src'); mainImg.srcset = b.getAttribute('data-srcset') || ''; mainImg.alt = b.getAttribute('data-alt') || '';
          mainImg.classList.toggle('is-contain', b.hasAttribute('data-contain'));
          mainImg.setAttribute('data-current', id);
          var done = function () { mainImg.classList.remove('is-swapping'); };
          if (mainImg.complete) requestAnimationFrame(done); else { mainImg.onload = done; mainImg.onerror = done; }
        };
        if (reduced || !mainImg.getAttribute('data-current')) swap();
        else { mainImg.classList.add('is-swapping'); setTimeout(swap, 180); }
      }
      $$('.um-gal__thumbs button, .um-gal__strip button', pdp).forEach(function (x) { x.classList.toggle('is-on', x.getAttribute('data-media-id') === id); });
    }
    function updateCount() {
      if (!track || !count) return;
      var slides = visibleSlides(); if (!slides.length) return;
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      i = Math.max(0, Math.min(slides.length - 1, i));
      count.textContent = (i + 1) + ' / ' + slides.length;
      var id = slides[i].getAttribute('data-media-id');
      $$('.um-gal__strip button', pdp).forEach(function (x) { x.classList.toggle('is-on', x.getAttribute('data-media-id') === id); });
    }
    if (track) {
      var tk = false;
      track.addEventListener('scroll', function () { if (tk) return; tk = true; requestAnimationFrame(function () { updateCount(); tk = false; }); }, { passive: true });
    }
    $$('.um-gal__thumbs button', pdp).forEach(function (b) { b.addEventListener('click', function () { selectMedia(b.getAttribute('data-media-id')); }); });
    $$('.um-gal__strip button', pdp).forEach(function (b) {
      b.addEventListener('click', function () {
        var slides = visibleSlides(), id = b.getAttribute('data-media-id');
        for (var i = 0; i < slides.length; i++) if (slides[i].getAttribute('data-media-id') === id) { track.scrollTo({ left: i * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' }); break; }
      });
    });

    function render() {
      current = find();
      var soonNow = isSoon(state.colour);
      /* sizes: strike the ones that are sold out in a released colour */
      $$('.um-sizes button', pdp).forEach(function (b) {
        var v = P.variants.filter(function (x) { return (ci < 0 || x.options[ci] === state.colour) && x.options[si] === b.getAttribute('data-value'); })[0];
        b.classList.toggle('is-on', b.getAttribute('data-value') === state.size);
        b.setAttribute('aria-pressed', b.getAttribute('data-value') === state.size ? 'true' : 'false');
        if (!soonNow && (!v || !v.available)) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
      });
      $$('.um-sw button', pdp).forEach(function (b) {
        var on = b.getAttribute('data-value') === state.colour;
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (idInput && current) idInput.value = current.id;
      if (priceEl && current) priceEl.textContent = current.price_label;
      if (err) err.classList.remove('is-shown');
      cta.classList.remove('um-btn--ghost'); cta.disabled = false;
      if (soonNow) {
        cta.classList.add('um-btn--ghost');
        cta.textContent = P.t.notify.replace('[colour]', state.colour);
        stock.textContent = P.t.soon_line.replace('[colour]', state.colour);
        if (notify) {
          var tags = notify.querySelector('input[name="contact[tags]"]');
          if (tags) tags.value = 'notify-me, notify-' + colourKey(state.colour) + ', notify-' + P.handle + '-' + colourKey(state.colour);
          var who = notify.querySelector('[data-notify-colour]'); if (who) who.textContent = state.colour;
        }
      } else {
        if (notify && !notify.classList.contains('is-posted')) notify.classList.remove('is-shown');
        if (current && current.available) { cta.textContent = P.t.add; stock.textContent = P.t.stock_line; }
        else { cta.textContent = P.t.sold_out; cta.disabled = true; stock.textContent = P.t.sold_out_line; }
      }
      if (bar) {
        var bb = bar.querySelector('.um-btn'), bp = bar.querySelector('[data-bar-price]');
        if (bb) { bb.textContent = soonNow ? P.t.notify_short : (cta.disabled ? P.t.sold_out : P.t.add); bb.disabled = cta.disabled; }
        if (bp && current) bp.textContent = current.price_label + (state.colour ? ' · ' + state.colour : '') + (state.size ? ' · ' + state.size : '');
      }
      if (current && window.history.replaceState && !DESIGN) {
        var u = new URL(window.location.href); u.searchParams.set('variant', current.id); window.history.replaceState({}, '', u.toString());
      }
    }
    $$('.um-sw button', pdp).forEach(function (b) {
      b.addEventListener('click', function () { state.colour = b.getAttribute('data-value'); showGallery(); render(); });
    });
    $$('.um-sizes button', pdp).forEach(function (b) {
      b.addEventListener('click', function () { state.size = b.getAttribute('data-value'); render(); });
    });
    if (form) form.addEventListener('submit', function (e) {
      if (isSoon(state.colour)) {
        e.preventDefault();
        if (notify) { notify.classList.add('is-shown'); var inp = notify.querySelector('input[type=email]'); if (inp) inp.focus(); }
        return;
      }
      if (!current || !current.available || !cartEl()) return; /* no drawer: plain POST to /cart/add */
      e.preventDefault();
      cta.classList.add('is-busy');
      cartPost('/cart/add.js', { items: [{ id: current.id, quantity: 1 }] })
        .then(function (j) {
          swapCart(j.sections && j.sections[CART_SECTION]);
          cta.textContent = P.t.added || 'Added to bag'; cta.classList.add('is-added');
          setTimeout(function () { cta.classList.remove('is-added'); render(); }, 1600);
          setTimeout(openCart, reduced ? 0 : 350);
        })
        .catch(function (x) { if (err) { err.textContent = x.message; err.classList.add('is-shown'); } })
        .then(function () { cta.classList.remove('is-busy'); });
    });
    /* phone buy bar = remote control for the real button */
    if (bar) {
      var bb = bar.querySelector('.um-btn');
      if (bb) bb.addEventListener('click', function () {
        if (isSoon(state.colour)) { pdp.querySelector('.um-pdp__cta').scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' }); if (notify) notify.classList.add('is-shown'); return; }
        if (form.requestSubmit) form.requestSubmit(cta); else cta.click();
      });
      var ctaBox = pdp.querySelector('.um-pdp__cta');
      if ('IntersectionObserver' in window && ctaBox) {
        new IntersectionObserver(function (es) {
          var e = es[0]; bar.classList.toggle('is-shown', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(ctaBox);
      }
    }
    showGallery(); render();
    if (notify && notify.classList.contains('is-posted')) notify.classList.add('is-shown');
  }

  /* ---------- footer: menus collapse on phones, always open on desktop ---------- */
  var footMq = window.matchMedia('(max-width:767px)');
  function syncFooter() { $$('.um-fcol').forEach(function (d) { d.open = !footMq.matches; }); }
  if (footMq.addEventListener) footMq.addEventListener('change', syncFooter); else if (footMq.addListener) footMq.addListener(syncFooter);
  syncFooter();

  /* ---------- section opening (Nik r3): each section after the first unfolds from a slight inset and rises in ---------- */
  var openIO = null;
  function initOpen(root) {
    if (!('IntersectionObserver' in window)) return;
    if (!openIO) openIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting && e.boundingClientRect.top > 0) return;
        var s = e.target; openIO.unobserve(s); s.classList.add('is-open');
        setTimeout(function () { s.classList.remove('um-open', 'is-open'); }, 1700); /* drop the clip/transform once open: sticky + fixed children stay normal */
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0 });
    var secs = $$('#MainContent > .shopify-section');
    secs.forEach(function (s, i) {
      if (root !== doc && !root.contains(s) && root !== s) return;
      if (i === 0 || s.querySelector('.um-hero, .um-pdp, .um-about__hero') || s.classList.contains('um-open')) return;
      if (s.getBoundingClientRect().top < window.innerHeight * 0.92) return; /* already on screen at load: leave it */
      s.classList.add('um-open'); openIO.observe(s);
    });
  }

  /* ---------- init + theme editor ---------- */
  function initAll(root) {
    initMotion(root);
    initOpen(root);
    initReveals(root);
    $$('.um-world', root).forEach(initWorld);
    $$('.um-pdp', root).forEach(initProduct);
  }
  initAll(doc);
  motionFrame();
  doc.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  doc.addEventListener('shopify:section:select', function (e) {
    var s = e.target; s.classList.remove('um-open'); s.classList.add('is-open');
    $$('.um-r, .um-rz', s).forEach(function (el) { el.classList.add('in'); });
  });
  doc.addEventListener('shopify:block:select', function (e) {
    var li = e.target; if (li && li.matches && li.matches('.um-world__pins > li')) {
      var w = li.closest('.um-world'), m = w && w.querySelector('.um-world__map');
      if (m && m.__um && m.__um.focus) m.__um.focus(li.getAttribute('data-id'));
    }
  });
})();
